import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch, faTruck } from "@fortawesome/free-solid-svg-icons";

export default function MahilaMandiXpressHome() {
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [basketPrepared, setBasketPrepared] = useState(false);
  const [basketItems, setBasketItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [orderDetails, setOrderDetails] = useState({ name: "", address: "", pin: "", mobile: "", email: "" });
  const [orderPlaced, setOrderPlaced] = useState(false);

  const categories = [
    { name: "Pickles & Preserves", img: "🥒" },
    { name: "Handmade Soaps", img: "🧼" },
    { name: "Baked Goods", img: "🍪" },
    { name: "Herbal Teas", img: "☕" },
    { name: "Textiles", img: "🧵" },
    { name: "Jewelry", img: "💍" },
    { name: "Candles", img: "🕯️" },
    { name: "Pottery", img: "🏺" },
    { name: "Handicrafts", img: "🪡" },
  ];

  const dummyItems = {
    "Pickles & Preserves": [
      { name: "Mango Pickle", unit: "jar", marketPrice: 180, offerPrice: 150, img: "https://via.placeholder.com/80?text=Mango+Pickle" },
      { name: "Lemon Pickle", unit: "jar", marketPrice: 140, offerPrice: 120, img: "https://via.placeholder.com/80?text=Lemon+Pickle" },
      { name: "Garlic Pickle", unit: "jar", marketPrice: 130, offerPrice: 110, img: "https://via.placeholder.com/80?text=Garlic+Pickle" },
      { name: "Mixed Fruit Jam", unit: "jar", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Fruit+Jam" },
      { name: "Chili Pickle", unit: "jar", marketPrice: 160, offerPrice: 140, img: "https://via.placeholder.com/80?text=Chili+Pickle" },
    ],
    "Handmade Soaps": [
      { name: "Lavender Soap", unit: "bar", marketPrice: 100, offerPrice: 80, img: "https://via.placeholder.com/80?text=Lavender+Soap" },
      { name: "Rose Soap", unit: "bar", marketPrice: 110, offerPrice: 90, img: "https://via.placeholder.com/80?text=Rose+Soap" },
      { name: "Cinnamon Soap", unit: "bar", marketPrice: 120, offerPrice: 95, img: "https://via.placeholder.com/80?text=Cinnamon+Soap" },
      { name: "Aloe Vera Soap", unit: "bar", marketPrice: 105, offerPrice: 85, img: "https://via.placeholder.com/80?text=Aloe+Soap" },
      { name: "Neem Soap", unit: "bar", marketPrice: 115, offerPrice: 95, img: "https://via.placeholder.com/80?text=Neem+Soap" },
    ],
    "Baked Goods": [
      { name: "Oatmeal Cookies", unit: "pack", marketPrice: 220, offerPrice: 200, img: "https://via.placeholder.com/80?text=Oatmeal+Cookies" },
      { name: "Brownies", unit: "pack", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Brownies" },
      { name: "Besan Ladoo", unit: "pack", marketPrice: 240, offerPrice: 220, img: "https://via.placeholder.com/80?text=Besan+Ladoo" },
      { name: "Gingerbread", unit: "pack", marketPrice: 230, offerPrice: 210, img: "https://via.placeholder.com/80?text=Gingerbread" },
      { name: "Rusk", unit: "pack", marketPrice: 150, offerPrice: 130, img: "https://via.placeholder.com/80?text=Rusk" },
    ],
    "Herbal Teas": [
      { name: "Herbal Blend", unit: "pack", marketPrice: 270, offerPrice: 250, img: "https://via.placeholder.com/80?text=Herbal+Tea" },
      { name: "Chamomile Tea", unit: "pack", marketPrice: 240, offerPrice: 220, img: "https://via.placeholder.com/80?text=Chamomile" },
      { name: "Masala Chai", unit: "pack", marketPrice: 260, offerPrice: 240, img: "https://via.placeholder.com/80?text=Masala+Chai" },
      { name: "Hibiscus Tea", unit: "pack", marketPrice: 250, offerPrice: 230, img: "https://via.placeholder.com/80?text=Hibiscus" },
      { name: "Tulsi Tea", unit: "pack", marketPrice: 230, offerPrice: 210, img: "https://via.placeholder.com/80?text=Tulsi+Tea" },
    ],
    "Textiles": [
      { name: "Cotton Scarf", unit: "pcs", marketPrice: 370, offerPrice: 350, img: "https://via.placeholder.com/80?text=Cotton+Scarf" },
      { name: "Handkerchief", unit: "pcs", marketPrice: 120, offerPrice: 100, img: "https://via.placeholder.com/80?text=Handkerchief" },
      { name: "Woolen Shawl", unit: "pcs", marketPrice: 470, offerPrice: 450, img: "https://via.placeholder.com/80?text=Woolen+Shawl" },
      { name: "Kurta Fabric", unit: "m", marketPrice: 320, offerPrice: 300, img: "https://via.placeholder.com/80?text=Kurta+Fabric" },
      { name: "Embroidered Dupatta", unit: "pcs", marketPrice: 500, offerPrice: 450, img: "https://via.placeholder.com/80?text=Embroidered+Dupatta" },
    ],
    "Jewelry": [
      { name: "Beaded Earrings", unit: "set", marketPrice: 220, offerPrice: 200, img: "https://via.placeholder.com/80?text=Beaded+Earrings" },
      { name: "Clay Necklace", unit: "pcs", marketPrice: 300, offerPrice: 280, img: "https://via.placeholder.com/80?text=Clay+Necklace" },
      { name: "Jhumka Earrings", unit: "set", marketPrice: 270, offerPrice: 250, img: "https://via.placeholder.com/80?text=Jhumka" },
      { name: "Rakhi Bracelet", unit: "set", marketPrice: 170, offerPrice: 150, img: "https://via.placeholder.com/80?text=Rakhi+Bracelet" },
      { name: "Silver Anklets", unit: "pair", marketPrice: 400, offerPrice: 350, img: "https://via.placeholder.com/80?text=Anklets" },
    ],
    "Candles": [
      { name: "Soy Candle", unit: "pcs", marketPrice: 270, offerPrice: 250, img: "https://via.placeholder.com/80?text=Soy+Candle" },
      { name: "Lavender Candle", unit: "pcs", marketPrice: 240, offerPrice: 220, img: "https://via.placeholder.com/80?text=Lavender+Candle" },
      { name: "Diya Candle", unit: "pcs", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Diya+Candle" },
      { name: "Pine Candle", unit: "pcs", marketPrice: 280, offerPrice: 260, img: "https://via.placeholder.com/80?text=Pine+Candle" },
      { name: "Sandalwood Candle", unit: "pcs", marketPrice: 290, offerPrice: 270, img: "https://via.placeholder.com/80?text=Sandalwood" },
    ],
    "Pottery": [
      { name: "Clay Mug", unit: "pcs", marketPrice: 320, offerPrice: 300, img: "https://via.placeholder.com/80?text=Clay+Mug" },
      { name: "Flower Pot", unit: "pcs", marketPrice: 200, offerPrice: 180, img: "https://via.placeholder.com/80?text=Flower+Pot" },
      { name: "Rain Vase", unit: "pcs", marketPrice: 240, offerPrice: 220, img: "https://via.placeholder.com/80?text=Rain+Vase" },
      { name: "Color Bowl", unit: "pcs", marketPrice: 180, offerPrice: 160, img: "https://via.placeholder.com/80?text=Color+Bowl" },
      { name: "Terracotta Plate", unit: "set", marketPrice: 350, offerPrice: 320, img: "https://via.placeholder.com/80?text=Terracotta+Plate" },
    ],
    "Handicrafts": [
      { name: "Wooden Coasters", unit: "set", marketPrice: 250, offerPrice: 220, img: "https://via.placeholder.com/80?text=Wooden+Coasters" },
      { name: "Paper Mache Box", unit: "pcs", marketPrice: 180, offerPrice: 160, img: "https://via.placeholder.com/80?text=Paper+Mache" },
      { name: "Bamboo Basket", unit: "pcs", marketPrice: 300, offerPrice: 280, img: "https://via.placeholder.com/80?text=Bamboo+Basket" },
      { name: "Wall Hanging", unit: "pcs", marketPrice: 400, offerPrice: 350, img: "https://via.placeholder.com/80?text=Wall+Hanging" },
      { name: "Macrame Plant Holder", unit: "pcs", marketPrice: 220, offerPrice: 200, img: "https://via.placeholder.com/80?text=Macrame+Holder" },
      { name: "Quilled Greeting Cards", unit: "set", marketPrice: 150, offerPrice: 130, img: "https://via.placeholder.com/80?text=Quilled+Cards" },
      { name: "Clay Figurines", unit: "pcs", marketPrice: 280, offerPrice: 250, img: "https://via.placeholder.com/80?text=Clay+Figurines" },
    ],
  };

  const offersOfTheDay = [
    { name: "Mango Pickle", offerQty: 2, msg: "Buy 2 Jars Mango Pickle at ₹140 each!" },
    { name: "Lavender Soap", offerQty: 3, msg: "Buy 3 Bars Lavender Soap at ₹70 each!" },
    { name: "Oatmeal Cookies", offerQty: 1, msg: "Get Oatmeal Cookies Pack at ₹180 today!" },
    { name: "Herbal Tea", offerQty: 2, msg: "Buy 2 Packs Herbal Tea at ₹220 each!" },
    { name: "Cotton Scarf", offerQty: 1, msg: "Get Handwoven Cotton Scarf at ₹320 today!" },
    { name: "Wooden Coasters", offerQty: 1, msg: "Get Wooden Coasters Set at ₹200 today!" },
  ];

  const handlePrepareBasket = () => {
    if (!selectedCategory) return alert("Select a category first!");
    if (!pinCode.trim() || !neighbourhood.trim()) return alert("Enter PIN Code and Neighbourhood!");
    setBasketItems(dummyItems[selectedCategory] || []);
    setBasketPrepared(true);
    setCart([]);
  };

  const handleAddToCart = (item) => {
    const existing = cart.find((c) => c.name === item.name);
    if (existing) {
      setCart(cart.map(c => c.name === item.name ? { ...c, qty: c.qty + 1 } : c));
    } else {
      setCart([...cart, { ...item, qty: 1 }]);
    }
  };

  const handleQtyChange = (itemName, delta) => {
    setCart(cart.map(c => {
      if (c.name === itemName) {
        const newQty = c.qty + delta;
        if (newQty <= 0) return null;
        return { ...c, qty: newQty };
      }
      return c;
    }).filter(Boolean));
  };

  const handleRemoveItem = (itemName) => setCart(cart.filter(c => c.name !== itemName));

  const handlePlaceOrder = () => {
    let offerMatched = false;
    offersOfTheDay.forEach(offer => {
      const cartItem = cart.find(c => c.name === offer.name);
      if (cartItem && cartItem.qty >= offer.offerQty) offerMatched = true;
    });
    if (offerMatched) {
      if (!window.confirm("Your cart qualifies for today's offer. Place order with offer?")) return;
    }
    if (cart.length === 0) return alert("Add at least one item to cart!");
    setShowOrderForm(true);
  };

  const handleSubmitOrder = () => {
    const { name, address, pin, mobile, email } = orderDetails;
    if (!name || !address || !pin || !mobile || !email) return alert("Fill all order details!");
    setOrderPlaced(true);
    setShowOrderForm(false);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-green-800 p-4 text-white flex flex-col md:flex-row md:items-center md:justify-between shadow-md">
        <h1 className="text-m lg:text-xl font-bold mb-2 md:mb-0">MahilaMandi Xpress: Delivery in few minutes</h1>
      </header>

      {/* Search Bar */}
      <div className="flex flex-row justify-center p-4 bg-black text-white shadow-sm">
        <div className="flex justify-start space-x-2">
          <FontAwesomeIcon className="mt-4" icon={faMapMarkerAlt} />
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="px-2 py-1 rounded text-black w-48 md:w-60"
          />
        </div>
        <div className="flex justify-start w-full bg-black border border-green-500 p-2 rounded-lg">
          <FontAwesomeIcon icon={faSearch} className="text-white" />
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Search neighbourhood or product"
            className="ml-2 bg-transparent outline-none flex-1"
          />
        </div>
      </div>

      {/* Categories Grid */}
      <div className="p-4 grid grid-cols-4 sm:grid-cols-7 gap-2 place-items-center">
        {categories.map((cat) => (
          <div
            key={cat.name}
            onClick={() => setSelectedCategory(cat.name)}
            className={`flex flex-col items-center bg-white rounded-xl shadow p-4 cursor-pointer hover:scale-105 transition transform ${
              selectedCategory === cat.name ? "border-2 border-green-700" : ""
            }`}
          >
            <div className="text-4xl mb-2">{cat.img}</div>
            <span className="text-sm font-medium text-center">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Prepare Basket Button */}
      <div className="p-4 flex justify-center items-center">
        <button
          onClick={handlePrepareBasket}
          className="w-48 bg-green-700 text-white py-2 rounded-lg hover:bg-green-800 flex items-center justify-center space-x-2"
        >
          Prepare Your Basket
        </button>
      </div>

      {/* Basket Items */}
      {basketPrepared && (
        <>
          <div className="p-4 bg-black border border-green-400 rounded shadow mb-4">
            <h3 className="text-yellow-300 text-xl font-bold">🔥 Offers of the Day 🔥</h3>
            <ul className="list-disc text-white pl-5">
              {offersOfTheDay.map((offer) => (
                <li key={offer.name}>{offer.msg}</li>
              ))}
            </ul>
          </div>

          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {basketItems.map((item) => (
              <div key={item.name} className="bg-black text-white border border-green-500 p-4 rounded shadow flex flex-col items-center">
                <img src={item.img} alt={item.name} className="w-20 h-20 object-cover mb-2 rounded" />
                <span className="font-medium text-white">{item.name} ({item.unit})</span>
                <span className="line-through text-sm text-white">₹{item.marketPrice} / {item.unit}</span>
                <span className="text-white font-bold">₹{item.offerPrice} / {item.unit}</span>
                <button
                  onClick={() => handleAddToCart(item)}
                  className="mt-2 w-20 bg-green-600 text-white py-1 px-3 rounded hover:bg-green-700"
                >
                  Add
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Cart & Place Order */}
      {basketPrepared && (
        <div className="p-4">
          <h3 className="text-yellow-200 text-m  lg:text-xl font-bold mb-2">Cart</h3>
          {cart.length === 0 ? (
            <p>No items added yet.</p>
          ) : (
            <div className="space-y-2">
              {cart.map((c) => (
                <div key={c.name} className="flex justify-between bg-black text-white border border-green-500 p-2 rounded shadow items-center">
                  <div className="flex items-center gap-2">
                    <img src={c.img} alt={c.name} className="w-10 h-10 object-cover rounded" />
                    <span>{c.name} ({c.unit})</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleQtyChange(c.name, -1)}
                      className="bg-blue-700 text-white px-2 rounded hover:bg-blue-800"
                    >
                      -
                    </button>
                    <span>{c.qty}</span>
                    <button
                      onClick={() => handleQtyChange(c.name, +1)}
                      className="bg-blue-700 text-white px-2 rounded hover:bg-blue-800"
                    >
                      +
                    </button>
                    <span>₹{c.offerPrice * c.qty}</span>
                    <button
                      onClick={() => handleRemoveItem(c.name)}
                      className="bg-red-600 text-white px-2 rounded hover:bg-red-700"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button
            onClick={handlePlaceOrder}
            className="mt-4 w-48 bg-green-700 text-white py-2 rounded-lg flex items-center justify-center space-x-2 hover:bg-green-800"
          >
            <FontAwesomeIcon icon={faTruck} />
            <span>Place Xpress Order</span>
          </button>
        </div>
      )}

      {/* Order Form */}
      {showOrderForm && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-m lg:text-xl font-bold mb-2">Enter Delivery Details</h3>
          <div className="flex flex-col gap-2 justify-start">
            {["name", "address", "pin", "mobile", "email"].map((field) => (
              <input
                key={field}
                type="text"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={orderDetails[field]}
                onChange={e => setOrderDetails({ ...orderDetails, [field]: e.target.value })}
                className="p-2 border rounded"
              />
            ))}
          </div>
          <button
            onClick={handleSubmitOrder}
            className="mt-4 w-36 bg-green-700 text-white py-2 rounded hover:bg-green-800"
          >
            Confirm Order
          </button>
        </div>
      )}

      {/* Dummy Invoice */}
      {orderPlaced && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-xl font-bold mb-2">Order Placed Successfully!</h3>
          <h3 className="text-white font-bold mb-2">You shall get the delivery in 5-10 minutes!</h3>
          <h3 className="text-white text-xl font-bold mb-2">This is COD Order. Pay on delivery by Cash or digitally.</h3>
          <p>Invoice / Delivery Challan:</p>
          <ul className="list-disc pl-5">
            {cart.map((c) => (
              <li key={c.name}>
                {c.name} ({c.unit}) x {c.qty} = ₹{c.offerPrice * c.qty}
              </li>
            ))}
          </ul>
          <p>Total: ₹{cart.reduce((a, b) => a + b.offerPrice * b.qty, 0)}</p>
        </div>
      )}

      {/* Footer */}
      <footer className="mt-auto bg-green-800 text-white text-center p-4 text-sm">
        © 2025 MahilaMandi Xpress by Think5Whys
      </footer>
    </div>
  );
}